<template>
  <section id="dashboard-users">
    <b-row class="match-height">
      <b-col
        xl="6"
        md="6"
      >
        <ecommerce-medal :data="userData" />
      </b-col>
      <b-col
        lg="6"
        sm="6"
      >
        <b-card
          class="card"
        >
          <h5>Selamat Datang</h5>
          <b-card-text class="m-auto">
            Aplikasi Pendaftaran {{ appName }} Universitas Indonesia 
          </b-card-text>
          <b-card-text class="m-auto">
            <strong>Penting:</strong> Batas waktu terakhir pemberian rekomendasi adalah tanggal {{ appDateline }}
          </b-card-text>
          <br>
        </b-card>
      </b-col>
      <b-col
        lg="6"
        sm="6"
        v-if="!$can('manage','all-content')"
      >
        <timeline-basic />
      </b-col>
      <b-col
        lg="6"
        sm="6"
        style="height: 50px;"
        v-if="!$can('manage','all-content')"
      >
        <jadwal-ujian-wawancara />
        <timeline-basic-perekomendasi />
      </b-col>
    </b-row>
<!-- 
    <b-row class="match-height" v-if="$can('manage','all-content')">
      <b-col
        xl="12"
        md="12"
      >
        <ecommerce-statistics :data="statisticsItems" />
      </b-col>
       <b-col
          lg="4"
          md="4"
          cols="4"
        >
          <ecommerce-order-chart :data="pengajuanTiapStatus" />
        </b-col>
        <b-col
          lg="4"
          md="4"
          cols="4"
        >
          <ecommerce-order-chart2 :data="pengajuanTiapJenjang" />
        </b-col>
        <b-col
          lg="4"
          md="4"
          cols="4"
        >
          <hasil-sidang-berdasarkan-status :data="donutChart" />
        </b-col>
    </b-row> -->
  </section>
</template>

<script>
import { BRow, BCol, BCard, BCardText, BButton } from 'bootstrap-vue'

import StatisticCardWithAreaChart from '@core/components/statistics-cards/StatisticCardWithAreaChart.vue'
import { kFormatter } from '@core/utils/filter'
import TimelineBasic from './TimelineBasic.vue'
import TimelineBasicPerekomendasi from './TimelineBasicPerekomendasi.vue'
import JadwalUjianWawancara from './JadwalUjianWawancara.vue'
import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import AnalyticsCongratulation from './AnalyticsCongratulation.vue'
import AnalyticsAvgSessions from './AnalyticsAvgSessions.vue'
import AnalyticsSupportTracker from './AnalyticsSupportTracker.vue'
import AnalyticsTimeline from './AnalyticsTimeline.vue'
import AnalyticsSalesRadarChart from './AnalyticsSalesRadarChart.vue'
import AnalyticsAppDesign from './AnalyticsAppDesign.vue'
import EcommerceMedal from './EcommerceMedal.vue'
// import EcommerceStatistics from './EcommerceStatistics.vue'
// import EcommerceRevenueReport from './EcommerceRevenueReport.vue'
// import EcommerceOrderChart from './EcommerceOrderChart.vue'
// import EcommerceOrderChart2 from './EcommerceOrderChart2.vue'
// import EcommerceProfitChart from './EcommerceProfitChart.vue'
// import EcommerceEarningsChart from './EcommerceEarningsChart.vue'
// import EcommerceCompanyTable from './EcommerceCompanyTable.vue'
// import EcommerceMeetup from './EcommerceMeetup.vue'
// import EcommerceBrowserStates from './EcommerceBrowserStates.vue'
// import EcommerceGoalOverview from './EcommerceGoalOverview.vue'
// import EcommerceTransactions from './EcommerceTransactions.vue'
// import HasilSidangBerdasarkanStatus from './HasilSidangBerdasarkanStatus.vue'
import {
  getUserDetailDashboard,
  downloadFileDashboard,
  getSettingByKey,
} from '@/connection-api/master'
import { $themeColors } from '@themeConfig'
const chartColors = {
  column: {
    series1: '#826af9',
    series2: '#d2b0ff',
    bg: '#f8d3ff',
  },
  success: {
    shade_100: '#7eefc7',
    shade_200: '#06774f',
  },
  donut: {
    series1: '#ffe700',
    series2: '#00d4bd',
    series3: '#826bf8',
    series4: '#2b9bf4',
    series5: '#FFA1A1',
  },
  area: {
    series3: '#a4f8cd',
    series2: '#60f2ca',
    series1: '#2bdac7',
  },
}


export default {
  components: {
    BRow,
    BCol,
    BButton,
    TimelineBasic,
    TimelineBasicPerekomendasi,
    JadwalUjianWawancara,
    // AnalyticsCongratulation,
    // AnalyticsAvgSessions,
    // StatisticCardWithAreaChart,
    // AnalyticsSupportTracker,
    // AnalyticsTimeline,
    // AnalyticsSalesRadarChart,
    // AnalyticsAppDesign,
    // InvoiceList,
    BCard,
    BCardText,
    EcommerceMedal,
    // EcommerceStatistics,
    // EcommerceRevenueReport,
    // EcommerceOrderChart,
    // EcommerceProfitChart,
    // EcommerceEarningsChart,
    // EcommerceCompanyTable,
    // EcommerceMeetup,
    // EcommerceBrowserStates,
    // EcommerceGoalOverview,
    // EcommerceTransactions,
    // EcommerceOrderChart2,
    // HasilSidangBerdasarkanStatus,
  },
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      appDateline: process.env.VUE_APP_DATELINE || 'Memuat...',
      data:{},
      userData: {},
      statisticsItems: [
        {
          icon: 'BoxIcon',
          color: 'light-primary',
          title: '0',
          subtitle: 'Total Pengajuan',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'UserIcon',
          color: 'light-info',
          title: '0',
          subtitle: 'Dalam Proses Persetujuan',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'Edit3Icon',
          color: 'light-info',
          title: '0',
          subtitle: 'Terjadwal',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'CheckIcon',
          color: 'light-success',
          title: '0',
          subtitle: 'Selesai',
          customClass: 'mb-2 mb-sm-0',
        },
      ],
      temp_series: [],
      pengajuanTiapStatus: {
         series: [
          {
            name: 'Jumlah',
            data: [0, 0, 0],
          },
        ],
        chartOptions: {
          chart: {
            type: 'bar',
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          grid: {
            show: true,
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '20%',
              colors: {
                backgroundBarRadius: 5,
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: true,
          },
          colors: [$themeColors.info],

          xaxis: {
            categories: ['Dalam Proses', 'Terjadwal', 'Selesai'],
            labels: {
              show: true,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: true,
          },
          tooltip: {
            x: {
              show: true,
            },
          },
        },
      },
      pengajuanTiapJenjang: {
          series: [
            {
              name: 'Jumlah',
              data: [0, 0, 0],
            },
          ],
          chartOptions: {
            chart: {
              type: 'bar',
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            grid: {
              show: true,
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '20%',
                colors: {
                  backgroundBarRadius: 5,
                },
              },
            },
            legend: {
              show: false,
            },
            dataLabels: {
              enabled: true,
            },
            colors: [$themeColors.success],

            xaxis: {
              categories: ['S1', 'S2', 'S3'],
              labels: {
                show: true,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            yaxis: {
              show: true,
            },
            tooltip: {
              x: {
                show: true,
              },
            },
          },
        },
      donutChart: {
        series: [0,0,0],
        chartOptions: {
          chart: {
            type: 'pie',
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          legend: {
            show: true,
            position: 'bottom',
            fontSize: '14px',
            fontFamily: 'Montserrat',
          },
          colors: [
            chartColors.donut.series1,
            chartColors.donut.series5,
            chartColors.donut.series3,
            chartColors.donut.series2,
          ],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                  name: {
                    fontSize: '2rem',
                    fontFamily: 'Montserrat',
                  },
                  value: {
                    fontSize: '1rem',
                    fontFamily: 'Montserrat',
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`
                    },
                  },
                  // total: {
                  //   show: true,
                  //   fontSize: '1.5rem',
                  //   label: 'Lulus Tanpa Revisi',
                  //   formatter() {
                  //     return '31%'
                  //   },
                  // },
                },
              },
            },
          },
          labels: ['Lulus Dengan Revisi', 'Lulus Tanpa Revisi', 'Tidak Lulus'],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: 'bottom',
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: '1.5rem',
                        },
                        value: {
                          fontSize: '1rem',
                        },
                        total: {
                          fontSize: '1.5rem',
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },
    }
  },
  mounted() {
    if(!this.$can('manage','all'))
    {
      if(localStorage.getItem('token'))
      {
        if(localStorage.getItem('tipe'))
        {
          if(localStorage.getItem('tipe') == 'wawancara')
          {
            const token = this.$route.params.token
            if(token === undefined){
              this.$router.push(`/form-pewawancara/wawancara/${localStorage.getItem('token')}`)
            }
          } else {
            const token = this.$route.params.token
            if(token === undefined){
              this.$router.push(`/form-perekomendasi/rekomendasi/${localStorage.getItem('token')}`)
            }
          }
        }
      }
    }
  },
  created() {
    // Fetch dateline setting from API
    getSettingByKey('batas_waktu_rekomendasi')
      .then(response => {
        if (response.data && response.data.status && response.data.status.code === '00') {
          this.appDateline = response.data.data.value
        }
      })
      .catch(() => {
        // fallback to .env value
      })

    // data
    // this.$http.get('/analytics/data')
    //   .then(response => { this.data = response.data })

    // this.$http.get('/ecommerce/data')
    // .then(response => { 
    //   this.data = response.data 
    //   })
    if(this.$route.params.id) {

      getUserDetailDashboard(this.$route.params.id)
       .then(response => {
         this.userData = response.data.data;
         if(this.userData.foto === null){
           this.userData.foto = this.logo
         }
         if(this.$can('manage','all-content')){
           this.statisticsItems[0].title = this.userData.statistik.total
           this.statisticsItems[1].title = this.userData.statistik.dalam_proses
           this.statisticsItems[2].title = this.userData.statistik.terjadwal
           this.statisticsItems[3].title = this.userData.statistik.selesai
 
           var dataBarChart = {
               name: 'Jumlah',
               data: [
                 this.userData.statistik.dalam_proses,
                 this.userData.statistik.terjadwal,
                 this.userData.statistik.selesai
               ]
             }
 
           this.temp_series.push(dataBarChart)
           this.pengajuanTiapStatus.series = this.temp_series
 
           this.temp_series = []
           var dataBarChart2 = {
               name: 'Jumlah',
               data: [
                 this.userData.jenjang.s1,
                 this.userData.jenjang.s2,
                 this.userData.jenjang.s3
               ]
             }
 
           this.temp_series.push(dataBarChart2)
           this.pengajuanTiapJenjang.series = this.temp_series
 
           this.pieChart([
                 this.userData.hasil.lulus_dr,
                 this.userData.hasil.lulus_tr,
                 this.userData.hasil.tidak_lulus,
               ])
         }
       })
       .catch(error => console.log(error));
    }
  },
  methods: {
    pieChart(seriesPie)
    {
       this.donutChart = {
        series: seriesPie,
        chartOptions: {
          chart: {
            type: 'pie',
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          legend: {
            show: true,
            position: 'bottom',
            fontSize: '14px',
            fontFamily: 'Montserrat',
          },
          colors: [
            chartColors.donut.series1,
            chartColors.donut.series5,
            chartColors.donut.series3,
            chartColors.donut.series2,
          ],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                  name: {
                    fontSize: '2rem',
                    fontFamily: 'Montserrat',
                  },
                  value: {
                    fontSize: '1rem',
                    fontFamily: 'Montserrat',
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`
                    },
                  },
                  // total: {
                  //   show: true,
                  //   fontSize: '1.5rem',
                  //   label: 'Lulus Tanpa Revisi',
                  //   formatter() {
                  //     return '31%'
                  //   },
                  // },
                },
              },
            },
          },
          labels: ['Lulus Dengan Revisi', 'Lulus Tanpa Revisi', 'Tidak Lulus'],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: 'bottom',
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: '1.5rem',
                        },
                        value: {
                          fontSize: '1rem',
                        },
                        total: {
                          fontSize: '1.5rem',
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      }
    },
    kFormatter,
    async lihatFile(file) {
      try {
        if (typeof file === 'object') {
          // kode yang dijalankan jika file adalah object
          file = file.nama
        }
        const resp = await downloadFileDashboard(file);
        var type_file = file.substring(file.length - 4);
        if (type_file === ".pdf") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "application/pdf" })
          );
        }
        if (type_file === ".png" || type_file === ".PNG" || 
            type_file === ".jpg" || type_file === ".JPG" || 
            type_file === ".jpeg" || type_file === ".JPEG") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "image/" + type_file.slice(1) })
          );
        }
        window.open(this.imageFile);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hasil Sidang',
            icon: 'EditIcon',
            variant: 'danger',
            text: 'File tidak ditemukan',
          },
          duration: 5000,
        })
      }
    },
  },
}
</script>
